import { Component, Input } from '@builder.io/sdk';

import { buttonFields } from 'molecules/Button/config';
import { formFields } from 'molecules/Form/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

const containedConversionPanelFields = [
  {
    name: 'heading',
    type: 'string',
    defaultValue: 'Looking for startup pricing?',
    helperText: 'Main heading displayed at the top of the conversion panel.',
  },
  {
    name: 'body',
    type: 'longText',
    defaultValue: 'Everything you need to build and deploy embedded integrations to your customers.',
    helperText: 'Supporting description text that explains the offer or conversion message.',
  },
  imageField('image'),
  {
    name: 'useForm',
    type: 'boolean',
    defaultValue: false,
    helperText: 'Use a Marketo form instead of a button.',
  },
  {
    name: 'button',
    type: 'object',
    subFields: buttonFields,
    helperText: 'Optional call-to-action button configuration (label, URL, style, and icons).',
    showIf: "options.get('useForm') === false",
  },
  ...formFields(),
  ...sectionFields,
  {
    name: 'formLayout',
    type: 'enum',
    enum: ['inline', 'stacked'],
    defaultValue: 'stacked',
    helperText: 'Layout style for the Marketo form.',
    showIf: "options.get('useForm') === true",
  },
  {
    name: 'lockedContentPageId',
    type: 'string',
    helperText: 'Page ID for locked content tracking (auto-populated by Article component).',
    advanced: true,
    showIf: "options.get('useForm') === true",
  },
] as const satisfies DeepReadonly<Input[]>;

const containedConversionPanelConfig = {
  name: 'Contained Conversion Panel',
  inputs: containedConversionPanelFields,
} as Component;

export interface ContainedConversionPanelConfigProps
  extends Omit<GenerateBuilder<typeof containedConversionPanelFields>, 'form'>, FormFieldProps {
  useForm?: boolean;
  showGradientTop?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onFormSuccess?: (ctx?: { values?: Record<string, any> }) => boolean | void;
  lockedContentPageId?: string;
  theme?: 'default' | 'teal';
}

export default containedConversionPanelConfig;
